import { render, staticRenderFns } from "./home.vue?vue&type=template&id=8f075928&scoped=true"
import script from "./home.vue?vue&type=script&lang=ts&setup=true"
export * from "./home.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./home.vue?vue&type=style&index=0&id=8f075928&prod&scoped=true&lang=css"
import style1 from "./home.vue?vue&type=style&index=1&id=8f075928&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f075928",
  null
  
)

export default component.exports